<div class="bg-base-100 flex h-full w-full flex-col">
	<a routerLink="/host/dashboard">
		<header class="navbar bg-base-200 border-base-300 border-b">
			<div class="flex-1">
				<a
					class="btn btn-ghost text-xl"
					routerLink="/admin"
					[translate]
					>Admin dashboard</a
				>
			</div>
			<div class="flex-none">
				<ul class="menu menu-horizontal px-1">
					<li>
						<span [translate]>Back to Dashboard</span>
					</li>
				</ul>
			</div>
		</header>
	</a>
	<div class="flex w-full grow overflow-hidden">
		<aside class="menu bg-base-200 rounded-box m-3 w-44 shrink-0">
			<ul>
				<li>
					<a
						routerLink="/admin/translations"
						routerLinkActive="active"
						[translate]
						>Translations</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/emails"
						routerLinkActive="active"
						[translate]
						>Emails</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/tasks"
						routerLinkActive="active"
						[translate]
						>Tasks</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/users"
						routerLinkActive="active"
						[translate]
						>Users</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/tickets"
						routerLinkActive="active"
						[translate]
						>Articles and tickets</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/feedback"
						routerLinkActive="active"
						[translate]
						>Feedback</a
					>
				</li>
				<li>
					<a
						routerLink="/admin/cronjobs"
						routerLinkActive="active"
						[translate]
						>Cron Jobs</a
					>
				</li>
				@for (navigationItem of additionalNavigationItems; track navigationItem.path) {
					<li>
						<a [routerLink]="navigationItem.path" routerLinkActive="active">
							<span>{{ navigationItem.label() }}</span>
						</a>
					</li>
				}
				<li>
					<a
						routerLink="/admin/assistant-tools"
						routerLinkActive="active"
						[translate]
						>Assistant tools</a
					>
				</li>
			</ul>
		</aside>
		<div class="grow overflow-hidden p-4">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
